var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 196.7 198.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7b52a8;stroke:#3d3548;stroke-miterlimit:10;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.5 0.5 0.5 197.5 195.5 0.5 0.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.74,111.16,13.89,87.34l3-3.8,34.75,3.82.14.92L28.19,69.43l3.31-4.15L61.34,89.1l-3.06,3.84L23.91,89.35l-.14-.91L47.05,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.21,73.65q-3.55,4.45-8,4.91t-9-3.19l-2.4-1.92q-4.77-3.8-5.5-8.24T52,56.51a9.37,9.37,0,0,1,7.94-3.88q4.71.16,10.06,4.42l1.39,1.11L59.9,72.54l-3.37-2.69,8.29-10.39a9.2,9.2,0,0,0-5.12-1.88,4.8,4.8,0,0,0-3.94,1.94,5.82,5.82,0,0,0-1.37,4.93,8.55,8.55,0,0,0,3.36,4.84l2.72,2.16a7.07,7.07,0,0,0,5.19,1.84,6.81,6.81,0,0,0,4.57-2.82,8.35,8.35,0,0,0,1.5-2.94,9.26,9.26,0,0,0,.35-3.39l5-.55A15,15,0,0,1,76.55,69,12.89,12.89,0,0,1,74.21,73.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.06,55.67,61.49,45.23,65,40.85l18.24,8.37-11-17.47,2.33-2.91L94,35.67,81.83,19.74l3.5-4.38L101.4,39l-2.52,3.17L80,35.56,90.58,52.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.dd266863dfaf59d749cbdf43c981de3d.svg";
export { ForwardRef as ReactComponent };